import { FormattedMessage, useIntl } from 'react-intl'
import { AsyncView } from '@aboutbits/react-toolbox'
import { HeaderArea, HeaderTitle } from '../../shared/header'
import { ContentArea } from '../../shared/content'
import { Error } from '../../shared/error'
import { SectionListLoading } from '../../shared/section/SectionListLoading'
import { SectionActions } from '../../shared/section/SectionActions'
import { ButtonInternalLink } from '../../shared/button'
import { Variant } from '../../shared/button/Button'
import { Help } from '../../shared/help/Help'
import ProfileOverviewContent from './ProfileOverviewContent'
import { translationsProfile } from './translations/translations'
import { useGetUserSettings } from './db/userProfile'

export default function ProfileOverview() {
  const { data, error } = useGetUserSettings()
  const intl = useIntl()

  return (
    <>
      <HeaderArea>
        <HeaderTitle>
          <FormattedMessage {...translationsProfile.overviewTitle} />
        </HeaderTitle>
      </HeaderArea>
      <ContentArea>
        <AsyncView
          data={data}
          error={error}
          renderSuccess={(data) =>
            data && <ProfileOverviewContent data={data} />
          }
          renderError={(error) => <Error text={error && error.message} />}
          renderLoading={
            <SectionListLoading
              title={intl.formatMessage(translationsProfile.overviewTitle)}
            />
          }
        />
        <SectionActions>
          <ButtonInternalLink to="/profile/edit" variant={Variant.primary}>
            <span className="flex h-full items-center justify-center px-6">
              <FormattedMessage {...translationsProfile.editProfileTitle} />
            </span>
          </ButtonInternalLink>
        </SectionActions>
        <Help href="https://camid.eu" />
      </ContentArea>
    </>
  )
}
